import { hyperdbTriggers } from 'hyperdb-utils';
import httpRequest from '../../../helpers/httpRequest';
import upload from '../../../helpers/upload';
import * as config from '../../../../config';

const triggers = hyperdbTriggers({ config,
  triggerName: 'property',
  namespace: 'PROPERTY',
  entryPoint: '/properties',
  collectionName: 'properties',
  querySearchListing: [
    [
      'name',
      'surface',
      'nb_bedrooms',
      'nb_bathrooms',
      'active',
      'source_channel_id',
      ['group', ['name']],
      ['zone', ['name']],
      'content',
    ],
    { order: { id: 'asc' } }
  ],
  quickSearch: (keyword) => ({ $any: [{ name: { match: keyword } }] }),
  successMessageCreate: 'Property created',
  successMessageUpdate: 'Property updated',
  successMessageDelete: 'Property deleted',
});

export default {
  ...triggers,
  savePicture(dispatch, getState, { propertyId, picture }) { // TODO remove old file when update
    const data = {...picture};
    const url = config.APP_URL + `/properties/${propertyId}/upload-picture`;
    const file = data.image_file || {};
    if (data._new) delete data._new;
    delete data._new_position;
    data.original = data.original || {
      $type: 'file',
      value: {
        name: file.name,
        content_type: file.type,
        size: file.size,
        mtime: (new Date(file.lastModified || 0)).toISOString(),
      }
    };
    data.thumbnail = data.thumbnail || { $type: 'file', value: {} };
    data.hi_res = data.hi_res || { $type: 'file', value: {} };
    dispatch({ type: 'PROPERTY__UPLOAD_PICTURE' });
    return upload(url, data)
      .then(savedPicture => {
        dispatch({ type: 'PROPERTY__UPLOAD_PICTURE_SUCCESS', payload: savedPicture });
      })
      .catch(err => {
        dispatch({ type: 'PROPERTY__ERROR', payload: err });
      });
  },
  deletePicture(dispatch, getState, { propertyId, pictureId }) {
    const url = config.APP_URL + `/properties/${propertyId}/delete-picture/${pictureId}`;
    dispatch({ type: 'PROPERTY__DELETE_PICTURE' });
    return httpRequest('DELETE', url)
      .then(() => {
        dispatch({ type: 'PROPERTY__DELETE_PICTURE_SUCCESS' });
      })
      .catch(err => {
        dispatch({ type: 'PROPERTY__ERROR', payload: err });
      });
  },
  getPictures(dispatch, getState, { id, propName }) {
    const url = `/${id}/pictures`;
    return triggers.getData(dispatch, getState, { url, propName: propName || 'property_pictures' });
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/triggers.js